export default {
	setCandidateSummarySideMenuOpen (state, status) {
        state.candidateSummarySideMenuOpen = status
    },
}